import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Maintenance } from '../models';
import { AlloxApiService } from './allox-api.service';
import { Observable } from 'rxjs';

/**
 * メンテナンス状態を管理するサービス
 * @remarks
 * メンテナンスの取得・更新を行う。
 *
 */
@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  /** メンテナンス状態を取得・更新するAPIのエンドポイント */
  private path = '/maintenance_status';

  /**
   * @param http APIリクエストを行うためのサービス
   */
  constructor(private http: AlloxApiService) {}

  /**
   * メンテナンス状態を取得する
   *
   * @returns メンテナンス状態を含む `Maintenance` インスタンスの配列
   */
  public fetch(): Observable<Maintenance> {
    return this.http.get<{ status: number; updated_at: string; }>(this.path).pipe(
      map(obj =>
        obj && typeof obj === 'object'
          ? new Maintenance(obj)
          : null
      )
    );
  }

  /**
   * メンテナンス状態をAPI経由で更新する
   * @param {Maintenance} item - 更新するメンテナンスオブジェクト
   * @returns {Observable<Maintenance>} - 更新結果のObservable
   */
  public put(item: Maintenance): Observable<Maintenance> {
    const json = item.toJSON();
    return this.http.put<Maintenance>(this.path, json);
  }
}
